import React from 'react';

import css from './Skeleton.module.css';

const Skeleton = ({
  width = '50%',
  height = 16,
  bottom = 14,
  left = 0,
  top = 0,
  right = 0,
  circle = false,
  rounded = 0,
}) => {
  return (
    <div
      className={css.skeleton}
      style={{
        width,
        height,
        marginLeft: left,
        marginRight: right,
        marginBottom: bottom,
        borderRadius: rounded,
        marginTop: top,
        ...(circle && { borderRadius: '100%', height: width }),
      }}
    />
  );
};

export default Skeleton;
